import { render, staticRenderFns } from "./marketing-index.vue?vue&type=template&id=473c024a&"
import script from "./marketing-index.vue?vue&type=script&lang=ts&"
export * from "./marketing-index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports